import React from 'react';
import {
  Timeline,
  Expertise,
  Project,
  Contact,
  Navigation,
  Footer,
} from './components';
import PortfolioHero from './components/PortfolioHero';
import About from './components/About';
import EngineeringHighlights from './components/EngineeringHighlights';
import EngineeringPhilosophy from './components/EngineeringPhilosophy';
import CareerTimeline from './components/CareerTimeline';
import ThingsLearnedQuickly from './components/ThingsLearnedQuickly';
import AISection from './components/AISection';
import MobileSection from './components/MobileSection';
import Integrations from './components/Integrations';
import GitHubSection from './components/GitHubSection';
import CurrentlyExploring from './components/CurrentlyExploring';
import Blog from './components/Blog';
import Testimonials from './components/Testimonials';
import Education from './components/Education';
import JsonLd from './components/JsonLd';
import ScrollProgress from './components/ui/ScrollProgress';
import { useThemeMode } from './hooks/useThemeMode';

function PortfolioPage() {
  const { mode, handleModeChange } = useThemeMode();

  return (
    <>
      <ScrollProgress />
      <Navigation
        parentToChild={{ mode }}
        modeChange={handleModeChange}
        variant="work"
      />
      <div className={`main-container ${mode === 'dark' ? 'dark-mode dark' : 'light-mode'}`}>
        <JsonLd />
        <main>
          <PortfolioHero />
          <EngineeringHighlights />
          <About />
          <EngineeringPhilosophy />
          <ThingsLearnedQuickly />
          <CareerTimeline />
          <Timeline />
          <Project defaultView="technical" showToggle />
          <AISection />
          <CurrentlyExploring />
          <MobileSection />
          <Expertise />
          <Integrations />
          <GitHubSection />
          <Blog />
          <Testimonials />
          <Education />
          <Contact audience="engineering" />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default PortfolioPage;
